<template>
  <p>
    Caso você tenha efetuado o pagamento do seu acordo há menos de 7 dias, entre em contato com
    a central de atendimento o Itaú, para o cancelamento do mesmo.
  </p>

  <div v-for="contato in contatos" :key="contato.title" class="contato-item">
    <p>
      <strong>{{ contato.title }}</strong>
    </p>
    <ul>
      <li v-for="c in contato.values" :key="c">
        {{ c }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject } from 'vue';

interface Contato {
  title: string,
  values: string[],
}

export default defineComponent({
  props: {
    credor: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const businessRules = inject<Record<string, { contatos: Contato[] }>>('businessRules');
    const regrasCredor = computed(() => (businessRules ? businessRules[props.credor] : { contatos: [] }));
    const contatos = computed(() => regrasCredor.value.contatos);

    return {
      contatos,
    };
  },
});
</script>
<style lang="scss" scoped>
p:not(:first-of-type),
.contato-item:not(:first-of-type) {
  margin-top: 24px;
}

.contato-item {
  p {
    margin: 0;
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
